// extracted by mini-css-extract-plugin
module.exports = {"inputMagnifyingGlass":"_2jM0OI","secondarySearchButton":"jPRtxm","desktopSearchButton":"_10KwNu"};